import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTournamentsByDisplayOrder } from 'stores/match';
import * as _ from 'lodash';

export default function useTopTournaments(grouped = true) {
  const dispatch = useDispatch();
  const topTournamentsData = useSelector((state) => state.match.topTournaments);
  const [topTournaments, setTopTournaments] = useState([]);
  const tournamentNames = useSelector((state) => state.match.tournamentNames);

  function isOnlyCategory(topTournament) {
    return topTournamentsData.filter((t) => t.categoryId === topTournament.categoryId).length === 1;
  }

  function getTournamentLink(topTournament) {
    // const isCategory = isOnlyCategory(topTournament);
    // if (isCategory) {
    //   return `/sport-details/Football/matches?category=${topTournament.categoryId}`;
    // }
    return `/sport-details/Football/matches?category=${topTournament.categoryId}&league=${topTournament.id}`;
  }

  function groupTournaments() {
    const tempTopTournaments = [];
    _.orderBy(topTournamentsData, ['displayOrder'], ['asc']).forEach((topTournament, index) => {
      const categoryText = isOnlyCategory(topTournament)
        ? topTournament.categoryName
        : tournamentNames[topTournament.id]
      const tempTopTournament = {
        ...topTournament,
        text: categoryText ?? topTournament.categoryName,
        link: getTournamentLink(topTournament)
      };
      if (grouped) {
        if (index % 2 === 0) {
          tempTopTournaments.push([tempTopTournament]);
        } else {
          tempTopTournaments[tempTopTournaments.length - 1] = [
            ...tempTopTournaments[tempTopTournaments.length - 1],
            tempTopTournament
          ];
        }
      } else {
        tempTopTournaments.push(topTournament);
      }
    });

    setTopTournaments(tempTopTournaments);
  }

  useEffect(() => {
    dispatch(fetchTournamentsByDisplayOrder({ listLength: 20 }));
  }, []);

  useEffect(() => {
    groupTournaments();
  }, [topTournamentsData.length]);

  return topTournaments;
}
